module.exports = __webpack_public_path__ + "img/Loader-2.6197963f.png";